export var vkPushEvent = function vkPushEvent(goal) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3117532;
  if (typeof window === 'undefined') return;
  var _tmr = window._tmr || (window._tmr = []);
  _tmr.push({
    goal: goal,
    id: id,
    type: 'reachGoal'
  });
};